import { useState } from "react";
import { isEqual } from "lodash";

export function useManageEditImportedSyncEntity(
  importedOptions,
  onSubmit,
  type
) {
  const [selectedOptions, setSelectedOptions] = useState(importedOptions);

  return {
    options: selectedOptions,
    disabled: isEqual(selectedOptions, importedOptions),
    set: (_, { name, checked }) => {
      setSelectedOptions((prevStatuses) => {
        return prevStatuses.map((s) => {
          return s.externalId === name ? { ...s, isExcluded: !checked } : s;
        });
      });
    },
    submit: () => {
      const byExclusion = ({ isExcluded }) => {
        return isExcluded;
      };

      const byInclusion = ({ isExcluded }) => {
        return !isExcluded;
      };

      const toId = ({ externalId }) => {
        return externalId;
      };

      onSubmit(
        selectedOptions
          .filter(type === "exclusion" ? byExclusion : byInclusion)
          .map(toId)
      );
    },
  };
}

export default useManageEditImportedSyncEntity;
